export default "__VITE_ASSET__aw_BOLyx__"